<template>
  <section class="modal--container auth--container otp--container">
    <SectionLoader :show="isLoading" />
    <div class="title--text">
      {{ $t('general.otpTitle') }}
      <span v-if="from === 'register'">{{ $t('general.forRegister') }}</span>
      <span v-else-if="from === 'verify-phone'">{{ $t('general.forVerifyPhone') }}</span>
    </div>
    <div class="desc">
      {{ $t('general.otpSentTo') }}
      <span v-if="phone">{{ phone }}</span>
    </div>
    <!--    <div class="timer">-->
    <!--      05:00-->
    <!--    </div>-->
    <div class="otp--input">
      <!--      <input type="number" class="mr-4" v-model="otp1" :class="isFilled(otp1) ? 'filled' : ''" />-->
      <!--      <input type="number" class="mr-4" v-model="otp2" :class="isFilled(otp2) ? 'filled' : ''" />-->
      <!--      <input type="number" class="mr-4" v-model="otp3" :class="isFilled(otp3) ? 'filled' : ''" />-->
      <!--      <input type="number" v-model="otp4" :class="isFilled(otp4) ? 'filled' : ''" />-->
      <v-otp-input length="6" v-model="otp" type="number" @finish="verifyOtp"></v-otp-input>
      <span class="val-error" v-if="validation.hasError('otp')">{{
        validation.firstError('otp')
      }}</span>
      <div class="btn btn-primary main--btn" @click="verifyOtp">
        {{ $t('general.submitOtp') }}
      </div>
    </div>
    <div ref="turnstile" class="mb-3"></div>
    <div class="auth--link" :class="{ disabled: !canResendOtp }" @click="resendOtp">
      {{ $t('general.resendOtp') }}
    </div>
    <div v-if="allowOtpRequestAt">
      {{ $t('loginRegister.waitOtp') }}:<vue-countdown
        class="countdown"
        :time="new Date(allowOtpRequestAt) - new Date()"
        :interval="1000"
        :transform="transformSlotProps"
        @start="countdownStart"
        @end="countdownEnd"
        v-slot="{ minutes, seconds }"
        >{{ minutes }}:{{ seconds }}</vue-countdown
      >
    </div>
  </section>
</template>

<script>
import { Validator } from 'simple-vue-validator';
const SectionLoader = () => import('@/components/content-loading/section-loading');
import VueCountdown from '@chenfengyuan/vue-countdown';
import TurnstileMixin from '@/mixins/turnstile';

export default {
  props: ['phone', 'from'],
  mixins: [TurnstileMixin],
  components: {
    SectionLoader,
    VueCountdown,
  },
  data: () => ({
    otp: null,
    isLoading: false,
    allowOtpRequestAt: null,
    allowResend: true,
  }),
  validators: {
    otp(value) {
      return Validator.value(value).required(this.$i18n.t('errors.otp.required'));
    },
  },
  computed: {
    canResendOtp() {
      return this.allowResend && !this.isLoading && !this.isTurnstileLoading && this.turnstileToken;
    },
  },
  methods: {
    // isFilled(value) {
    //   return value !== null && value !== '';
    // },

    transformSlotProps(props) {
      const formattedProps = {};

      Object.entries(props).forEach(([key, value]) => {
        formattedProps[key] = value < 10 ? `0${value}` : String(value);
      });

      return formattedProps;
    },

    countdownEnd() {
      this.allowOtpRequestAt = null;
      this.allowResend = true;
    },
    countdownStart() {
      this.allowResend = false;
    },
    async resendOtp() {
      if (this.canResendOtp) {
        try {
          this.isLoading = true;
          const { data } = await this.$store.dispatch('global/sendOtp', {
            phone: this.phone,
            captchaToken: this.turnstileToken,
          });
          this.allowOtpRequestAt = data.allow_next_request_at;
          await this.refreshTurnstileToken();
        } catch (e) {
          await this.refreshTurnstileToken();
          const { status } = e.response || {};
          if (status === 465) {
            this.allowOtpRequestAt = e.response.data.allow_next_request_at;
          }
        } finally {
          this.isLoading = false;
        }
      }
    },
    async verifyOtp() {
      const isValid = await this.$validate();
      if (isValid) {
        this.$emit('verifyOtp', this.otp);
      }
    },
  },
  mounted() {
    this.prepareTurnstileToken(this.$refs.turnstile);
  },
  beforeDestroy() {
    this.removeTurnstileWidget();
  },
};
</script>
